import { useEffect, useState, useRef } from "react";
import { usePostOnboardingDataMutation } from "../../../store/api/onboardingApi";
import { useAppSelector } from "../../../hooks/store-hooks";
import { useNavigate } from "react-router-dom";
import { ONBOARDING_PAGE_ID } from "../../../constants";
import { ONBOARDING_ROUTE_MAPPING } from "../../../constants/routes";
import ProfilePicComp from "../../../components/onboarding/profile-pic";
import AuthLayout from "../../../components/layouts/auth";


const PersonalProfile = () => {
  const [userImage, setUserImage] = useState<string>("");

  const [postOnboardingData, { isLoading }] = usePostOnboardingDataMutation()

  const { data: onboardingData }: any = useAppSelector(state => state.onboarding || {})

  const navigate = useNavigate()

  const screenName = ONBOARDING_PAGE_ID.USER_PROFILE_PIC

  const defaultUserImage = useRef("");

  const onSubmit = async () => {
    const onboardingDataToPost = {page_id: screenName, profile_picture: ""}
    if (userImage !== defaultUserImage.current) {
      onboardingDataToPost.profile_picture = userImage;
    }
    const response = await postOnboardingData(onboardingDataToPost)
    if (response?.data?.success) {
      const nextPageId: any = response.data?.data?.nextPage || ""
      navigate(ONBOARDING_ROUTE_MAPPING?.[nextPageId])
    }
  };

  useEffect(() => {
    if (onboardingData?.page_id === screenName) {
      const pageData = onboardingData?.page_data || [];
      const imageUrl = pageData?.[0].value
      if(imageUrl) {
        defaultUserImage.current = imageUrl;
        setUserImage(imageUrl)
      }
    }

  }, [onboardingData])

  return (
    <AuthLayout screenName={screenName}>
      <div className="flex w-full h-full">
        <ProfilePicComp
          userImage={userImage}
          setUserImage={setUserImage}
          onSubmit={onSubmit}
          isLoading={isLoading}
          defaultUserImage={defaultUserImage}
        />
      </div>
    </AuthLayout>

  )
}

export default (PersonalProfile)  